import { ServiceInspectKey } from "./key";
import { useBaseQuery } from "../baseQuery";
import { DocsPdfServiceInspectUrl } from "@maven-rest/docs/pdf/Inspect.url";

export function useDocsPdfServiceInspectQuery() {
  return useBaseQuery({
    queryKey: [ServiceInspectKey.DocsPdfInspect],
    fnOption: {
      host: process.env.REACT_APP_DOCS_PDF_BE_URL,
      url: DocsPdfServiceInspectUrl.inspect,
    },
  });
}
